import React, { useEffect, useState } from 'react';
import { Loader } from '../../../../../../Common';
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import { useHistory } from 'react-router-dom';
import SearchSelectList from '../../../ProgramOnboarding/Components/Comman/SearchSelectedList';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { adminAPIURL } from '../../../../../../Config';
import { RxCross2 } from 'react-icons/rx';
import zoneV1 from '../../../../../../../assets/images/zone-v2.svg';
import zoneV2 from '../../../../../../../assets/images/zone-v3.svg';
import airplane from '../../../../../../../assets/images/airplane.svg';
import AddZone from '../../../ProgramOnboarding/Components/SelectZone/Components/AddZone';
import { ChevronLeft } from 'react-feather';
import cogoToast from 'cogo-toast';
import { SAVE_DRAFT_CONFIGURATION, UPDATE_DRAFT_CONFIGURATION, VALIDATE_ZONE } from '../../../../../../../store/actions';
import TypeCard from '../../../ProgramOnboarding/Components/Comman/TypeCard';

// import AddAirport from './Components/AddAirport';

const getInitialZones = () => ({
  airport: null,
  Road: [{ id: '', name: '', zoneRange: [0, 25] }],
  Radial: [{ id: '', name: '', zoneRange: [0, 25] }],
  Polygon: { id: '', name: '', serviceableAreas: '', nonServiceableAreas: '' },
});

const SelectZone = ({ state, setState, setFormCount, isDraftConfiguration, configuration }) => {
  const dispatch = useDispatch();

  const history = useHistory();
  const [zones, setZones] = useState(getInitialZones());
  const [selectedAirports, setSelectedAirports] = useState<any>([]);
  const [add, setAdd] = useState(false);
  const [activeAirport, setActiveAirport] = useState(null);
  const [distanceType, setDistanceType] = useState('Polygon');
  const [errors, setErrors] = useState<any>({
    Road: [],
    Radial: [],
    Polygon: { name: false, serviceableAreas: false, nonServiceableAreas: false },
    airport: false,
  });
  const [isUpdate, setIsUpdate] = useState(false);
  const [partiallyConfiguredNewZones, setPartiallyConfiguredNewZones] = useState([]);
  const [updatedZone, setUpdatedZone] = useState(null);

  const { validateZone } = useSelector((state: any) => ({
    validateZone: state.ValidateZone?.data,
  }));

  useEffect(() => {
    if (validateZone !== null) {
      if (partiallyConfiguredNewZones.length > 0) {
        setSelectedAirports(prevAirports => {
          const updated = [...prevAirports];
          const index = updated.findIndex(a => a.id === activeAirport?.id);

          if (index !== -1) {
            const zonesWithParent = partiallyConfiguredNewZones.map(zone => ({
              ...zone,
              airport: {
                id: activeAirport.id,
                name: activeAirport.name,
              },
            }));

            // Replace instead of append (OR append if required — choose one)
            updated[index] = {
              ...updated[index],
              zones: [...(updated[index].zones || []), ...zonesWithParent], // append instead
            };
          }

          return updated;
        });

        setZones(getInitialZones());
        setAdd(false);
        setPartiallyConfiguredNewZones([]);
      }
      if (updatedZone !== null) {
        setSelectedAirports(prevAirports => {
          const updated = [...prevAirports];
          const index = updated.findIndex(a => a.id === zones?.airport?.value);

          if (index !== -1) {
            // Clone zones
            const zonesArr = [...(updated[index].zones || [])];

            // Find the zone by id
            const zoneIdx = zonesArr.findIndex(z => z.id === updatedZone.id);

            if (zoneIdx !== -1) {
              // Update existing zone
              zonesArr[zoneIdx] = {
                ...zonesArr[zoneIdx],
                ...updatedZone,
                airport: {
                  id: activeAirport.id,
                  name: activeAirport.name,
                },
              };
            } else {
              // If not found, push new one
              zonesArr.push({
                ...updatedZone,
                airport: {
                  id: activeAirport.id,
                  name: activeAirport.name,
                },
              });
            }

            // Replace zones in airport
            updated[index] = {
              ...updated[index],
              zones: zonesArr,
            };
          }

          return updated;
        });

        setZones(getInitialZones());
        setAdd(false);
        setIsUpdate(false);
        setUpdatedZone(null);
      }
    }
  }, [validateZone]);

  useEffect(() => {
    setSelectedAirports(state?.vendorPricing?.airports ?? []);
    if (state?.vendorPricing?.airports?.length > 0) {
      setActiveAirport(state?.vendorPricing?.airports[0]);
    }
  }, [state]);

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    }
  };

  const handleSelectAirport = airport => {
    activeAirport?.id !== airport?.id && setActiveAirport(airport);
  };

  const removeZone = zoneToRemove => {
    setSelectedAirports(prevAirports => {
      const updated = [...prevAirports];
      const index = updated.findIndex(a => a.id === activeAirport?.id);

      if (index !== -1) {
        const restZones = updated[index]?.zones?.filter(zone => zone.id !== zoneToRemove.id);

        updated[index] = {
          ...updated[index],
          zones: restZones,
        };
      }

      return updated;
    });
  };

  const saveAsDraftHandler = () => {
    const hasMissingZones = selectedAirports?.some(airport => !airport.zones || airport.zones.length === 0);

    if (hasMissingZones) {
      cogoToast.error('Please select at least one zone for every airport.');
      return;
    }

    let payload = {
      data: {
        configuration_data: {
          benefit: {
            name: 'Airport Transfer',
          },
          multiProjects: state?.multiProjects,
          vendorPricing: {
            ...state?.vendorPricing,
            airports: selectedAirports,
          },
          configuration_type: 'vendor_onboarding',
          page: 5,
        },

        status: 'DRAFT',
      },
    };

    dispatch({
      type: SAVE_DRAFT_CONFIGURATION,
      payload: payload,
    });
  };

  const updateAsDraftHandler = () => {
    const hasMissingZones = selectedAirports?.some(airport => !airport.zones || airport.zones.length === 0);

    if (hasMissingZones) {
      cogoToast.error('Please select at least one zone for every airport.');
      return;
    }

    let payload = {
      data: {
        configuration_data: {
          benefit: {
            name: 'Airport Transfer',
          },
          multiProjects: state?.multiProjects,
          vendorPricing: {
            ...state?.vendorPricing,
            airports: selectedAirports,
          },
          page: 5,
        },
        configuration_type: 'vendor_onboarding',
        status: 'DRAFT',
        id: configuration?.id,
      },
    };

    dispatch({
      type: UPDATE_DRAFT_CONFIGURATION,
      payload: payload,
    });
  };

  const handleSubmit = () => {
    const hasMissingZones = selectedAirports?.some(airport => !airport.zones || airport.zones.length === 0);

    if (hasMissingZones) {
      cogoToast.error('Please select at least one zone for every airport.');
      return;
    }

    const selectedZoneIds = selectedAirports.flatMap(a => a.zones?.map(z => z.id) || []);

    console.log('Selected Zone IDs:', selectedZoneIds);

    setState(prev => ({
      ...prev,
      vendorPricing: {
        ...prev?.vendorPricing,
        airports: selectedAirports,
      },
    }));
    setFormCount((prev: number) => prev + 1);
  };

  const handleSelect = newZones => {
    setSelectedAirports(prevAirports => {
      const updated = [...prevAirports];
      const index = updated.findIndex(a => a.id === activeAirport?.id);
      if (index !== -1) {
        const zonesWithParent = newZones.map(zone => ({
          ...zone,
          airport: {
            id: activeAirport.id,
            name: activeAirport.name,
          },
        }));

        updated[index] = {
          ...updated[index],
          zones: zonesWithParent,
        };
      }

      return updated;
    });
  };

  const findZoneForActiveAirport = (): Array<any> => {
    const selectedAirport = selectedAirports?.find(airport => airport.id === activeAirport.id);
    return selectedAirport?.zones ?? [];
  };

  const isValidGeoJson = (geoJson: any): boolean => {
    if (!geoJson) return false;

    let parsed;
    try {
      parsed = typeof geoJson === 'string' ? JSON.parse(geoJson) : geoJson;
    } catch {
      return false; // Not valid JSON
    }

    // Helper: validate coordinates
    const validateCoords = (coords: any): boolean => {
      if (!Array.isArray(coords)) return false;

      // Point: [x, y]
      if (typeof coords[0] === 'number' && typeof coords[1] === 'number') {
        return coords.length === 2;
      }

      // Recursive check for nested arrays
      return coords.every(validateCoords);
    };

    // Case 1: FeatureCollection
    if (parsed?.type === 'FeatureCollection' && Array.isArray(parsed.features)) {
      if (parsed.features.length === 0) return false;

      for (const feature of parsed.features) {
        if (feature?.type !== 'Feature') return false;

        const geometry = feature?.geometry;
        if (!geometry?.type || !geometry.coordinates) return false;

        if (!validateCoords(geometry.coordinates)) return false;
      }
      return true;
    }

    // Case 2: Raw geometry object
    if (parsed?.type && parsed.coordinates) {
      return validateCoords(parsed.coordinates);
    }

    return false;
  };

  const isAnyZoneValid = () => {
    const currentZones = zones[distanceType];

    const currentZonesForRoad = zones['Road'];
    const currentZonesForRadial = zones['Radial'];

    if (currentZonesForRoad.length > 0) {
      const lastZoneForRoad = currentZonesForRoad[currentZonesForRoad.length - 1];

      if (lastZoneForRoad.zoneRange[0] === 0 && lastZoneForRoad.zoneRange[1] === 0) {
        cogoToast.error('Start and End cannot both be 0.');
        return false;
      }
    }

    if (currentZonesForRadial.length > 0) {
      const lastZoneForRadial = currentZonesForRadial[currentZonesForRadial.length - 1];

      if (lastZoneForRadial.zoneRange[0] === 0 && lastZoneForRadial.zoneRange[1] === 0) {
        cogoToast.error('Start and End cannot both be 0.');
        return false;
      }
    }

    // Name errors for Road / Radial zones
    const nameErrors = Array.isArray(currentZones) ? currentZones.map(zone => !zone?.name?.trim()) : [];

    // Polygon validation
    const polygonTouched = zones?.Polygon?.name?.trim() || zones?.Polygon?.serviceableAreas?.trim() || zones?.Polygon?.nonServiceableAreas?.trim();

    const shouldValidatePolygon = distanceType === 'Polygon' || polygonTouched;

    const polygonErrors = {
      name: shouldValidatePolygon ? !zones?.Polygon?.name?.trim() : false,
      serviceableAreas: shouldValidatePolygon ? !isValidGeoJson(zones?.Polygon?.serviceableAreas) : false,
      // ✅ nonServiceableAreas only validated if user entered something
      nonServiceableAreas:
        shouldValidatePolygon && zones?.Polygon?.nonServiceableAreas?.trim() ? !isValidGeoJson(zones?.Polygon?.nonServiceableAreas) : false,
    };

    const hasError = nameErrors.includes(true) || polygonErrors.name || polygonErrors.serviceableAreas || polygonErrors.nonServiceableAreas;

    if (hasError) {
      setErrors(prev => ({
        ...prev,
        [distanceType]: nameErrors,
        Polygon: polygonErrors,
      }));
      return false;
    }

    // ✅ Unique name check across all zones
    const allNames = [
      ...(zones?.Road || []).map(z => z.name?.trim().toLowerCase()),
      ...(zones?.Radial || []).map(z => z.name?.trim().toLowerCase()),
      zones?.Polygon?.name?.trim()?.toLowerCase?.() ? [zones?.Polygon?.name?.trim()?.toLowerCase()] : [],
    ].filter(Boolean);

    const hasDuplicate = allNames.some((name, idx) => allNames.indexOf(name) !== idx);
    if (hasDuplicate) {
      cogoToast.error('Zone names must be unique across all types.');
      return false;
    }

    // Helper for validity
    const isValidZone = (zone, type) => {
      if (!zone?.name?.trim()) return false;
      if (type === 'Polygon') {
        return (
          !!zone?.serviceableAreas?.trim() &&
          isValidGeoJson(zone?.serviceableAreas) &&
          // ✅ optional nonServiceableAreas
          (!zone?.nonServiceableAreas?.trim() || isValidGeoJson(zone?.nonServiceableAreas))
        );
      }
      return Array.isArray(zone.zoneRange) && zone.zoneRange[1] > zone.zoneRange[0];
    };

    const isRoadValid = zones?.Road?.some(zone => isValidZone(zone, 'Road'));
    const isRadialValid = zones?.Radial?.some(zone => isValidZone(zone, 'Radial'));
    const isPolygonValid = shouldValidatePolygon && zones.Polygon && isValidZone(zones.Polygon, 'Polygon');

    const isAnyValid = isRoadValid || isRadialValid || isPolygonValid;

    if (!isAnyValid) {
      cogoToast.error('Please configure at least one valid zone.');
      return false;
    }

    return true;
  };

  const handleCreateZone = () => {
    if (!isAnyZoneValid()) return;

    const newZones: any[] = [];

    // Helper to validate and push zone
    const pushValidZones = (type: 'Road' | 'Radial' | 'Polygon') => {
      if (type === 'Polygon') {
        const polygon = zones.Polygon;
        if (polygon?.name?.trim() && polygon?.serviceableAreas?.trim()) {
          newZones.push({
            id: Math.random().toString(36).substring(2, 10),
            distanceType: type,
            name: polygon.name,
            serviceableAreas: JSON.parse(polygon.serviceableAreas)?.features?.[0]?.geometry,
            // ✅ only include nonServiceableAreas if provided
            ...(polygon?.nonServiceableAreas?.trim()
              ? { nonServiceableAreas: JSON.parse(polygon.nonServiceableAreas)?.features?.[0]?.geometry }
              : {}),
            tag: 'partially_configured',
          });
        }
      } else {
        zones[type]?.forEach(zone => {
          if (zone?.name?.trim() && Array.isArray(zone.zoneRange) && zone.zoneRange[1] > zone.zoneRange[0]) {
            newZones.push({
              id: Math.random().toString(36).substring(2, 10),
              distanceType: type,
              name: zone?.name,
              zoneRange: { from: zone?.zoneRange.at(0), to: zone?.zoneRange.at(1) },
              tag: 'partially_configured',
            });
          }
        });
      }
    };

    // Collect valid zones of all types
    ['Road', 'Radial', 'Polygon'].forEach(type => pushValidZones(type as any));

    if (newZones.length === 0) {
      cogoToast.error('Please add at least one valid zone.');
      return;
    }

    setPartiallyConfiguredNewZones(newZones);

    dispatch({
      type: VALIDATE_ZONE,
      payload: {
        data: {
          reference_airport_id: activeAirport?.id,
          zone_details: newZones,
        },
      },
    });
  };

  const handleUpdateZone = () => {
    if (!isAnyZoneValid()) return;

    let payload;
    if (zones['Radial'].length > 0) {
      payload = {
        id: zones['Radial']?.[0]?.id,
        distanceType: 'Radial',
        name: zones['Radial']?.[0]?.name,
        zoneRange: { from: zones['Radial']?.[0]?.zoneRange.at(0), to: zones['Radial']?.[0]?.zoneRange.at(1) },
        tag: 'partially_configured',
      };
    } else if (zones['Road'].length > 0) {
      payload = {
        id: zones['Road']?.[0]?.id,
        distanceType: 'Road',
        name: zones['Road']?.[0]?.name,
        zoneRange: { from: zones['Road']?.[0]?.zoneRange.at(0), to: zones['Road']?.[0]?.zoneRange.at(1) },
        tag: 'partially_configured',
      };
    } else {
      payload = {
        id: zones['Polygon']?.id,
        distanceType: 'Polygon',
        name: zones['Polygon']?.name,
        ...(zones['Polygon']?.serviceableAreas && { serviceableAreas: JSON.parse(zones['Polygon']?.serviceableAreas) }),
        ...(zones['Polygon']?.nonServiceableAreas && { nonServiceableAreas: JSON.parse(zones['Polygon']?.nonServiceableAreas) }),
        tag: 'partially_configured',
      };
    }

    setUpdatedZone(payload);
    dispatch({
      type: VALIDATE_ZONE,
      payload: {
        data: {
          reference_airport_id: activeAirport?.id,
          zone_details: [payload],
        },
      },
    });
  };

  const handleUpdateMode = updateZone => {
    const selectedType = updateZone?.distanceType;

    // Base structure with airport
    const updatedZones = {
      airport: updateZone?.airport ? { value: updateZone?.airport?.id, label: updateZone?.airport?.name } : null,
      Road: [],
      Radial: [],
      Polygon: { id: '', name: '', serviceableAreas: '', nonServiceableAreas: '' },
    };

    // Set only the available type
    if (selectedType === 'Road') {
      updatedZones.Road = [{ id: updateZone?.id, name: updateZone?.name, zoneRange: Object?.values(updateZone?.zoneRange ?? {}) }];
    } else if (selectedType === 'Radial') {
      updatedZones.Radial = [{ id: updateZone?.id, name: updateZone?.name, zoneRange: Object?.values(updateZone?.zoneRange ?? {}) }];
    } else if (selectedType === 'Polygon') {
      updatedZones.Polygon = {
        id: updateZone?.id,
        name: updateZone?.name,
        serviceableAreas: updateZone?.serviceableAreas ? JSON.stringify(updateZone?.serviceableAreas) : '',
        nonServiceableAreas: updateZone?.nonServiceableAreas ? JSON.stringify(updateZone?.nonServiceableAreas) : '',
      };
    }
    console.log('check zone', updatedZones);
    setZones(updatedZones);
    setDistanceType(selectedType);
    setAdd(true);
    setIsUpdate(true);
  };

  return (
    <div className="page-content">
      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-1 align-items-center">
            <BreadcrumbTrail
              title={`Airport Configuration Setup`}
              navigationby={breadcrumNavigationHandler}
              navigation={['Management', 'Program', 'Onboarding', 'Select Zone']}
            />
          </div>

          {/* <Filter
            filterHandler={filterSubmitHandler}
            bookingType={bookingType}
            approvalRequestTypeHandler={approvalRequestTypeHandler}
            modification={modification}
          /> */}
        </div>

        <Card>
          <CardHeader className="d-flex justify-content-between p-0">
            <h5 className="m-0 fw-semibold px-3">Assign Vendor to the selected zones</h5>
            <TypeCard
              typeName={'Vendor'}
              name={`${state?.vendorPricing?.vendors?.[0]?.firstName || ''} ${state?.vendorPricing?.vendors?.[0]?.lastName || ''}`}
            />
          </CardHeader>
          <CardBody>
            <Row className="mb-3">
              {/* Search Airports */}
              <Col md="8">
                <SearchSelectList
                  label="Search Zone"
                  subLabel="Search and select zones to manage"
                  placeholder="Type zone name..."
                  selectedItems={findZoneForActiveAirport()}
                  isAddNew={false}
                  onSelect={newZones => handleSelect(newZones)}
                  searchApi={async query => {
                    if (activeAirport?.tag !== 'partially_configured') {
                      const res = await axios({
                        method: 'GET',
                        url: `${adminAPIURL}/v1/benefit-type/airport-transfer/zone`,
                        headers: {
                          'Project-Code': `ADMIN_ACCESS`,
                        },
                        params: {
                          name: query, // Changed `name` to `searchName`
                          zoneType: distanceType,
                          airportId: activeAirport?.id,
                          // draft: true,
                        },
                        withCredentials: true,
                      });
                      return res?.data?.results;
                    } else return [];
                  }}
                  renderItem={item => (
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex gap-2 align-items-center">
                        <img src={zoneV1} alt="" />
                        {item.name} {distanceType !== 'Polygon' && `(${item.zoneRange.from} - ${item.zoneRange.to})`}
                      </div>
                    </div>
                  )}
                  name="zone"
                  setAdd={setAdd}
                  distanceType={distanceType}
                  setDistanceType={setDistanceType}
                />
              </Col>

              {/* Selected Airports */}
              <Col md="4">
                <Card className="border rounded-3 p-3 mt-3 mb-3" style={{ height: '250px' }}>
                  <h6 className="fw-semibold">Selected Zone</h6>
                  <p className="text-muted mb-2 small">Currently selected airports ({selectedAirports?.length})</p>

                  <div className="mt-1 airport-list">
                    {selectedAirports.map(airport => {
                      const hasZones = airport?.zones?.length > 0;
                      const isActive = airport.id === activeAirport?.id;
                      return (
                        <div
                          key={airport.id}
                          onClick={() => handleSelectAirport(airport)}
                          style={{
                            background: '#EAEDF5',
                            borderRadius: '5px',
                            border: isActive ? '1px solid black' : '',
                          }}
                          className={`d-flex align-items-center mb-2 p-1 ps-3 px-3 cursor-pointer ${hasZones ? 'gap-3' : ''}`}
                        >
                          {hasZones && <img src={zoneV2} alt="" />}

                          <div>
                            {hasZones ? (
                              <>
                                <p className="m-0 fs-12">{airport.name}</p>
                                <div className="d-flex gap-2 flex-wrap mt-2">
                                  {airport.zones.map(zone => (
                                    <div key={zone.id} className="d-flex gap-2 align-items-center zone-list ps-2 px-2 justify-content-between">
                                      <p
                                        className="m-0 fs-10 text-truncate"
                                        style={{
                                          maxWidth: '100px',
                                          overflow: 'hidden',
                                          whiteSpace: 'nowrap',
                                          textOverflow: 'ellipsis',
                                        }}
                                      >
                                        {zone?.name?.split(' ').slice(0, 2).join(' ')}
                                      </p>
                                      {zone?.tag === 'partially_configured' && (
                                        <i className="ri-edit-line cursor-pointer" onClick={() => handleUpdateMode(zone)}></i>
                                      )}
                                      <RxCross2 size={15} className="cursor-pointer" onClick={() => removeZone(zone)} />
                                    </div>
                                  ))}
                                </div>
                              </>
                            ) : (
                              <div className="d-flex align-items-center gap-2">
                                <img src={airplane} alt="" />
                                <p className="m-0 fs-12">{airport.name}</p>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {add && (
          <Card className="p-3">
            <CardHeader tag="h5" className="border-bottom pb-2">
              Add Zone
            </CardHeader>
            <CardBody>
              <AddZone
                zones={zones}
                setZones={setZones}
                errors={errors}
                setErrors={setErrors}
                activeAirport={activeAirport}
                distanceType={distanceType}
                setDistanceType={setDistanceType}
                isCreateFromOnboarding={!isUpdate}
                isUpdate={isUpdate}
              />
              <div className="d-flex justify-content-between mt-4">
                <Button
                  className="btn btn-primary btn-light"
                  onClick={() => {
                    setAdd(false);
                    setZones(getInitialZones());
                    setIsUpdate(false);
                  }}
                >
                  Cancel
                </Button>
                <Button color="success" onClick={isUpdate ? handleUpdateZone : handleCreateZone}>
                  {isUpdate ? 'Update Zone' : 'Add Zone'}
                </Button>
              </div>
            </CardBody>
          </Card>
        )}

        <div className="d-flex justify-content-between">
          <Button
            onClick={() => {
              const selectedZoneIds = selectedAirports.flatMap(a => a.zones?.map(z => z.id) || []);

              setState(prev => ({
                ...prev,
                vendorPricing: {
                  ...prev?.vendorPricing,
                  airports: selectedAirports,
                  vendors:
                    prev?.vendorPricing?.vendors?.map(vendor => ({
                      ...vendor,
                      zones: vendor?.zones?.filter(zone => selectedZoneIds.includes(zone.id)) || [],
                    })) || [],
                },
              }));

              setFormCount((prev: number) => prev - 1);
            }}
            color="light"
            className="d-flex align-items-center gap-1 px-3 py-2"
            style={{
              backgroundColor: '#E9EBEC', // light gray
              color: '#404B7C', // navy/dark blue
              fontWeight: 500,
              boxShadow: 'none',
              border: 'none',
            }}
          >
            <ChevronLeft size={18} />
            Back
          </Button>
          <div className="d-flex gap-2">
            {isDraftConfiguration && (
              <Button className="btn btn-success" style={{ width: '150px' }} color="primary" onClick={updateAsDraftHandler}>
                Update As Draft
              </Button>
            )}

            {!isDraftConfiguration && (
              <Button className="btn btn-success" style={{ width: '130px' }} color="primary" onClick={saveAsDraftHandler}>
                Save As Draft
              </Button>
            )}
            <Button className="overlay-disable " style={{ width: '250px' }} color="primary" onClick={handleSubmit}>
              Manage Vendors
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SelectZone;
